import * as actionType from "./actionTypes";

//Adds to the cart and opens the cart drawer so the customer sees it land
export const addItem = (sku, quantity=1, openDrawer=true) => (
  (dispatch) => {
    dispatch({
      type: actionType.ADD_ITEM,
      sku,
      quantity,
    });
    if (openDrawer) {
      dispatch(setDrawerOpen(true));
    }
  }
);

export const setQuantity = (sku, quantity) => (
  {
    type: actionType.SET_QUANTITY,
    sku,
    quantity,
  }
);

export const removeItem = (sku) => (
  {
    type: actionType.REMOVE_ITEM,
    sku,
  }
);

//Removes anything that isn't in the list of skus currently for sale
export const removeUnavailable = (availableSkus) => (
  {
    type: actionType.REMOVE_UNAVAILABLE,
    availableSkus,
  }
);

export const clear = () => (
  {
    type: actionType.CLEAR,
  }
);

export const setDrawerOpen = (isOpen) => (
  {
    type: actionType.SET_DRAWER_OPEN,
    isOpen,
  }
);
